import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Calendar, ArrowRight } from 'lucide-react';
import Button from '../../../components/Button';

export default function ContactExpert() {
    return (
        <section className="mt-12">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="rounded-xl pt-8 pb-8 md:pt-10 md:pb-10"
            >
                <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
                    {/* Expert Portrait */}
                    <div className="relative flex-shrink-0">
                        <div className="relative w-28 h-28 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-white shadow-md">
                            <img
                                src="https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=2574&auto=format&fit=crop"
                                alt="Real Estate Expert"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="absolute bottom-1 right-1 bg-green-500 w-4 h-4 rounded-full border-2 border-white shadow-sm" />
                    </div>

                    {/* Content */}
                    <div className="flex-1 text-center md:text-left">
                        <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 tracking-widest uppercase">
                            Have more questions?
                        </h2>
                        <p className="text-gray-500 mb-8 max-w-xl text-sm md:text-base leading-relaxed">
                            Our real estate experts are available to help you understand the nuances of this investment opportunity.
                        </p>

                        <div className="flex flex-row gap-3 justify-center md:justify-start">
                            <Button
                                text="Message us"
                                icon={MessageCircle}
                                className="flex-1 text-[10px] sm:text-sm h-12 sm:h-auto"
                                onClick={() => { }}
                            />
                            <Button
                                text="Schedule a Call"
                                icon={Calendar}
                                className="flex-1 text-[10px] sm:text-sm h-12 sm:h-auto"
                                onClick={() => { }}
                            />
                        </div>
                    </div>
                </div>
            </motion.div>
        </section>
    );
}
